import {
  Component,
  inject,
  ViewChild,
  ElementRef,
  Input,
  ViewEncapsulation,
  OnDestroy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { interval, Observable, of } from 'rxjs';
import { Language } from '../../models/language.model';
import { selectLanguages } from '../../store/languages/languages.selects';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shuffle-languages',
  imports: [TranslateModule],
  template: `
    <div class="language-wrapper" #languageWrapper>
      <h3>{{ 'languages.' + languageList[0] | translate }}</h3>
    </div>
  `,
  styleUrl: './shuffle-languages.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ShuffleLanguagesComponent implements OnDestroy {
  @ViewChild('languageWrapper') languageWrapperRef!: ElementRef<HTMLDivElement>;
  @Input() timer: number = 1000;
  @Input() delay: number = 0;
  @Input() languageList: string[] = []; // Liste des langues spécifiques à ce composant

  private store: Store = inject(Store);
  private translateService: TranslateService = inject(TranslateService);
  $languages: Observable<readonly Language[]> =
    this.store.select(selectLanguages);
  private currentIndex: number = -1; // Commence à -1 pour que le premier appel affiche l'index 0
  interval: any;

  setRandomLanguage() {
    // Si aucune liste n'est fournie en input, charger toutes les langues
    if (this.languageList.length === 0) {
      this.$languages.subscribe((languages: readonly Language[]) => {
        this.languageList = languages.map((lang) => lang.name);
        this.updateLanguageDisplay();
      });
    } else {
      this.updateLanguageDisplay();
    }
  }

  updateLanguageDisplay() {
    if (this.languageList.length === 0) return;

    this.currentIndex = (this.currentIndex + 1) % this.languageList.length;
    const newLanguage = this.languageList[this.currentIndex];

    if (this.languageWrapperRef) {
      const wrapper: HTMLDivElement = this.languageWrapperRef.nativeElement;

      while (wrapper.children.length > 1) {
        wrapper.removeChild(wrapper.children[0]);
      }

      const lastChild: HTMLElement = wrapper.children[0] as HTMLElement;
      if (lastChild) {
        lastChild.classList.add('fade-out');
      }

      const h3: HTMLElement = document.createElement('h3');
      h3.classList.add('shuffled-language');
      h3.innerText = this.translateService.instant('languages.' + newLanguage);
      wrapper.appendChild(h3);
    }
  }

  ngOnInit() {
    // Commencer à un index aléatoire
    if (this.languageList.length > 0) {
      this.currentIndex =
        Math.floor(Math.random() * this.languageList.length) - 1;
    }

    this.setRandomLanguage();

    setTimeout(() => {
      this.interval = setInterval(() => {
        this.setRandomLanguage();
      }, this.timer);
    }, this.delay);
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
